import { useEffect, useRef } from 'react';

import { WebsiteInfo } from '../utils/formatWebsiteInfo';
import styles from './SourcesArea.module.scss';
import { WebsiteCard } from './WebsiteCard';

export const MAX_CUSTOM_SOURCES = 50;

interface SourcesAreaProps {
  items: WebsiteInfo[];
  handleRemove: (id: string) => void;
}

export const SourcesArea = ({ items, handleRemove }: SourcesAreaProps) => {
  const sourcesContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (sourcesContainerRef.current && items.length) {
      sourcesContainerRef.current.scrollTop =
        sourcesContainerRef.current.scrollHeight;
    }
  }, [items.length]);

  return (
    <div className={styles.sourcesList} ref={sourcesContainerRef}>
      {items.map(website => (
        <WebsiteCard
          key={website.id}
          {...website}
          handleRemove={handleRemove}
        />
      ))}
    </div>
  );
};
